import { render } from "./NewOrderExtras.vue?vue&type=template&id=176a04c1&scoped=true"
import script from "./NewOrderExtras.vue?vue&type=script&lang=js"
export * from "./NewOrderExtras.vue?vue&type=script&lang=js"

import "./NewOrderExtras.vue?vue&type=style&index=0&id=176a04c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176a04c1"]])

export default __exports__